import { Provider } from 'mobx-react';
import React, { Component } from 'react';
import { GlobalStyles } from './app.styles';
import { AppRouter } from './router';
import { RootStore } from './stores';

class App extends Component {
    public render(): React.ReactElement {
        return (
            <>
                <GlobalStyles />
                <Provider rootStore={new RootStore()}>
                    <AppRouter />
                </Provider>
            </>
        );
    }
}

export default App;
